//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { PackageStatus } from './Enums';

export class PackageDefinitionSearchOptions extends ItemBase {
    IDs: string[] = [];
    SearchText: string | null = null;
    TeacherIDs: string[] = [];
    TagIDs: string[] = [];
    Statuses: PackageStatus[] = [];

    constructor(initializer?: Partial<PackageDefinitionSearchOptions>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "PackageDefinitionSearchOptions";
}
